function LayoutLoading() {
    return (<div>
        ahihi
    </div>)
}

export default LayoutLoading;